<template>
  <div class="box gray-box">
    <div class="box-body inner-title">
      <el-row class="box-header">
        <el-col :span="18">
          <h3>支付方式</h3>
        </el-col>
        <el-col :span="6">
          <PaymentDialog :order="order" style="float:right;"><a style="cursor: pointer;">更改</a></PaymentDialog>
        </el-col>
      </el-row>
      <div class="content">
        <el-row class="total-line">
          <el-col class="name" :span="24">
            {{data.name}}
          </el-col>
        </el-row>
        <el-row class="total-line">
          <el-col :span="24">
            <i v-if="data.type == 4" class="ico ico-paypal"></i>
            <i v-if="data.type == 2" class="ico ico-wechatpay"></i>
            <i v-if="data.type == 3" class="ico ico-alipay"></i>
            <i v-if="data.type == 1" class="ico ico-mastercard"></i>
            <i v-if="data.type == 20" class="ico ico-company"></i>
            <i v-if="data.type == 0" class="ico ico-offpay"></i>
            <span v-if="data.type == 1">{{data.card_number | cardNumberEncrypt}}&nbsp;{{data.valid_date}}</span>
            <span class="payname" v-if="data.type == 2">微信支付</span>
            <span class="payname" v-if="data.type == 3">支付宝</span>
            <span class="payname" v-if="data.type == 0">私下支付</span>
            <span class="payname" v-if="data.type == 20">悦单支付</span>
            <!--<span class="payname" v-if="data.type == 4">Paypal</span>-->
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import PaymentDialog from './PaymentDialog'

export default {
  name: 'PaymentWay',
  props: ['data','order'],
  components: {
    PaymentDialog: PaymentDialog
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.total-line {
  color: #686B73;
  line-height: 22px;

  .name {
    font-size: 16px;
    margin-bottom: 5px;
  }
  .payname {
    font-size: 16px;
    margin-left: 5px;
  }
  .ico-offpay {
    background-image: url('../../../ico/ic_payment_cash.png');
    background-size: cover;
    width: 24px;
    height: 24px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/publish_task/payment/PaymentWay.vue